import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './changepass.scss'

// Actions
import { changePassword } from '../../../actions/auth'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Button from '../../../shared/elements/button'
import Text from '../../../shared/elements/text'

class ChangePass extends Component {

  constructor (props) {
    super(props)
    this.state = {
      OldPassword: '',
      NewPassword: '',
      ConfirmPassword: ''
    }
    this.onChange = this.onChange.bind(this)
    this.changePassword = this.changePassword.bind(this)
  }

  changePassword () {
    const { OldPassword, NewPassword, ConfirmPassword } = this.state
    if (NewPassword !== ConfirmPassword) {
      window.toastr.error(translation('14882'), translation('216'))
      return
    }

    const data = {
      UserId: 0,
      OldPassword: OldPassword,
      newPassWord: NewPassword
    }
    console.log('Change password', data)
    this.props.changePassword(data).then((res) => {
      console.log('Password changed', res.data)
      this.setState({
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      })
      // Toastr
      // window.toastr.success(translation('1083'), translation('13424'))
    }, (err) => {
      const { response: { data } } = err
      data.map((e) => {
        // Toastr
        window.toastr.error(translation(e.DictionaryKey), translation('216'))
      })
    })
  }

  onChange ({ target: { name, value } }) {
    this.setState({
      [name]: value
    })
  }

  render () {
    let { OldPassword, NewPassword, ConfirmPassword } = this.state
    return (
      <div className='password__screen'>
        <Col>
          <Panel title={translation('1777')}>
            <Text isPassword labelText={translation('1778')} name='OldPassword' value={OldPassword} onChange={this.onChange} />
            <Text isPassword labelText={translation('1077')} name='NewPassword' value={NewPassword} onChange={this.onChange} />
            <Text isPassword labelText={translation('14883')} name='ConfirmPassword' value={ConfirmPassword} onChange={this.onChange} />
            <Button onClick={this.changePassword} labelText={translation('1079')} />
          </Panel>
        </Col>
      </div>
    )
  }

}

function mapStateToProps (state) {
  console.debug('Hello, I\'m here!')
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  changePassword
})(ChangePass)



// WEBPACK FOOTER //
// ./src/app/pages/Auth/ChangePass/index.js